import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"

const AvailableScheduleHeader = () => {
  const header = [
    "Дата завершения",
    "ID",
    "Тип графика",
    "График",
    "Проект",
    "Направление",
    "Линия",
    "Кол-во графиков",
    "Потребность для рекрутеров",
    "На этапе собеседования",
    "На этапе оформления",
    "На этапе обучения",
    "Отсев после собеседования",
    "Оказывает услуги",
    "Кол-во графиков осталось",
    "Транслируем в найм",
  ]

  const headerForRecruiter = [
    "Дата завершения",
    "ID",
    "Тип графика",
    "График",
    "Проект",
    "Направление",
    "Линия",
    "Кол-во графиков",
    "Кол-во графиков осталось",
  ]

  const isNotRecruiter = () => {
    return keycloakInstance.realmAccess?.roles.some((role) =>
      [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-viewer",
        "hiring-training",
      ].includes(role),
    )
  }

  const currentHeader = isNotRecruiter() ? header : headerForRecruiter

  return (
    <TableRow
      sx={{
        bgcolor: (theme) =>
          theme.palette.mode === "dark"
            ? "rgb(55, 55, 55)"
            : "rgba(225, 225, 225, 1)",
        width: "100vh",
      }}
    >
      {currentHeader.map((item) => (
        <TableCell
          key={item}
          sx={{
            whiteSpace: item?.length > 14 ? "normal" : "nowrap",
            // item?.length > 20 ? "normal" :
            lineHeight: "1.2",
            fontSize: "14px",
            minWidth: item.length > 30 ? "200px" : "auto",
            maxHeight: "54px !important",
            fontWeight: "bold",
            ":first-of-type": {
              borderRadius: "4px 0 0 4px",
            },
            ":last-of-type": {
              borderRadius: "0px 4px 4px 0px",
            },
            height: "57px",
          }}
        >
          {item}
        </TableCell>
      ))}
    </TableRow>
  )
}

export default AvailableScheduleHeader
